(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gallery-arrows"] && !Shopify.designMode) return;
  try {
    document.addEventListener('keydown', function (event) {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    if (event.defaultPrevented || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;

    /* Arrow keys already mean something in fields, selects, sliders and
       radio groups, so those keep them. */
    var target = event.target;
    if (target && target.closest) {
      if (target.isContentEditable) return;
      if (target.closest('input, textarea, select, [contenteditable], [role="slider"], [role="radiogroup"], [role="tablist"], [role="menu"], [role="listbox"]')) return;
    }

    var step = event.key === 'ArrowRight' ? '1' : '-1';
    var buttons = document.querySelectorAll('[data-gallery-step="' + step + '"]');
    for (var index = 0; index < buttons.length; index++) {
      /* The first gallery that is actually on screen: offsetParent is null
         for anything hidden. */
      if (buttons[index].offsetParent !== null) {
        event.preventDefault();
        buttons[index].click();
        return;
      }
    }
  });
  } catch(e) { console.error(e); }
})();

})();
